<template>
    <main class="flex1">
        <router-view />
    </main>
</template>
<script>
export default {
    name: 'myContainer',
}
</script>
<style lang="less" scoped>
main{
    width: 1200px;
    margin: 40px auto 0;
}
</style>